import { API_PATH } from 'common/constants/services';
import useQuery from 'hook/useQuery';
import React, { useMemo } from 'react';

export default function usePartsQuery() {
  const partQuery = useQuery<PartResponse>(API_PATH.PARTS);

  const data = useMemo(
    () => partQuery.getQuery.data?.data.results,
    [partQuery],
  );

  return {
    data,
    status: partQuery.getQuery.status,
    error: partQuery.getQuery.error,
    isError: partQuery.getQuery.isError,
    isLoading: partQuery.getQuery.isLoading,
  };
}
